import Isotope from 'isotope-layout';
import {Fancybox} from "@fancyapps/ui";

function init() {
  const gallery = document.querySelector('.gallery-list');
  if (gallery) {
    const iso = new Isotope(gallery, {
      itemSelector: '.gallery-list_item',
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 8
      }
    });

    document.querySelectorAll('.gallery-filter-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        Array.from(document.querySelectorAll('.gallery-filter-btn')).forEach(
          (el) => el.classList.remove('active')
        );
        // @ts-ignore
        var filterValue = e.target.getAttribute('data-filter');
        // @ts-ignore
        e.target.classList.add('active');
        iso.arrange({
          filter: function( itemIndex, itemElem ) {
            if (filterValue === '*') {
              Fancybox.destroy();
              // @ts-ignore
              Fancybox.bind(".gallery-list a", {
                contentClick: false,
                buttons: ['close'],
                groupAll: true,
                Thumbs : {
                  type: "classic"
                }
              });
              return true;
            }
            Fancybox.destroy();
            // @ts-ignore
            Fancybox.bind("[data-fancybox]", {
              contentClick: false,
              buttons: ['close'],
              Thumbs : {
                type: "classic"
              }
            });
            return itemElem.classList.contains(filterValue);
          },
        });
      })
    })
  }
}

function initGallery() {
  // @ts-ignore
  Fancybox.bind("[data-fancybox]", {
    contentClick: false,
    buttons: ['close'],
    Thumbs : {
      type: "classic"
    }
  });
}

export default function Gallery() {
  init();
  initGallery();
}
